import { mapActions } from 'vuex'
import { plainToClass } from 'class-transformer'
import Matching from '@/models/matching'
import Response from '@/utils/response'
import PageLoading from '@/mixins/page-loading'
import Row from '../Row/Bundle'

export default {
  components: {
    Row,
  },
  mixins: [
    PageLoading,
  ],
  props: {
    repository: Object
  },
  data: () => ({
    matchings: [],
  }),
  computed: {
    unanswersCount () {
      return this.matchings.reduce((a,e) => {
        return a + e.matchingships.reduce((b,e2) => {
          return b + (e2.answeredAt ? 0 : 1)
        }, 0)
      }, 0)
    },
  },
  mounted () {
    this.clearToolbarTitle()
    this.fetchData()
  },
  methods: {
    ...mapActions([
      'clearToolbarTitle',
    ]),
    async fetchData () {
      if (this.loading) return
      this.loading = true
      try {
        const response = new Response(await this.repository.get())
        this.matchings = plainToClass(Matching, response.result)
        this.$store.commit('matching/setUnanswerCount', this.unanswersCount)
      } catch (error) {
        this.loading = false
        this.$store.commit('setAxiosError', error)
      } finally {
        this.loading = false
      }
    },
    onAnswer (matchingship) {
      this.$router.push({
        name: 'matchingship-answer',
        params: { id: matchingship.id },
      })
    },
    onResult (matchingship) {
      this.$router.push({
        name: 'answer-show',
        params: { id: matchingship.answer.id },
        query: { from: this.$route.path },
      })
    },
    onMatchingResult (matching) {
      this.$router.push({
        name: 'matching-summary',
        params: { id: matching.id },
      })
    },
    tabPrev () {
      this.$router.push({ name: "root" })
    }
  }
}
